import DamageDetail from './damageDetail';
import { useParams } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import { get } from '../../../services/apiController';
import { toast, ToastContainer } from 'react-toastify';

const JWDamagePrint = () => {
  const formFields = {
    companyId: '',
    chargeType: '',
    chargeAmount: '',
    jwDamageNumber: '',
    jwDamageDate: '',
    total: '',
    assetsInfo: [],
  };
  let params = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [grnForm, setGrnForm] = useState(formFields);

  const getGrnData = () => {
    try {
      setIsLoading(true);
      get(`/inv/jw-damage/${params.id}`).then((res) => {
        const Data = res.data;
        setGrnForm(Data);
        setIsLoading(false);
      });
    } catch (error) {
      setIsLoading(false);
      toast.error(error?.response?.data?.data?.rows?.message || 'Something went wrong');
    }
  };

  useEffect(() => {
    getGrnData();
  }, []);

  return (
    <>
      <ToastContainer />
      {isLoading ? <Spinner animation="border" variant="info" /> : <DamageDetail data={grnForm} isPrint={true} />}
    </>
  );
};

export default JWDamagePrint;
